import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { map, Observable, startWith, Subscription } from 'rxjs';
import { RGPDLabs, RGPDPreferences } from 'src/app/api/models/rgpdLabs';
import { AuthService, ComunicadosService, RgpdService } from 'src/app/api/services';
import { CustomIconsService } from 'src/app/api/services/custom-icons.service';
import { PerfilService } from 'src/app/api/services/perfil.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-rgpd',
    templateUrl: './rgpd.component.html',
    styleUrls: ['./rgpd.component.css'],
    standalone: false
})
export class RgpdComponent {
  rgpdText1: string = environment.rgpdText1;
  rgpdText2: string = environment.rgpdText2;
  isLoading: boolean = false;
  mainLabs: RGPDLabs[] = [];
  selectedMainLabs: string[] = [];
  unsubscribe: Subscription = new Subscription();
  currentUser = this.perfilServ.getCurrentUserInfo();
  otherLabs: RGPDLabs[] = [];
  selectedOtherLabs: RGPDLabs[] = []; 
  labCtrl = new FormControl('');
  filteredLabs!: Observable<any[]>;
  otherLabsControl = new FormControl<string[]>([]); 

  constructor(
    private authService: AuthService,
    private router: Router,
    private comunicadoServ: ComunicadosService,
    private rgpdService: RgpdService,
    private perfilServ: PerfilService,
    private iconsService: CustomIconsService
  ) {}

  ngOnInit() {
    this.getMainRgpdLabs();

    this.getOtherRgpdLabs();

    this.filteredLabs = this.labCtrl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const searchValue = typeof value === 'string' ? value : '';
        return this._filter(searchValue);
      })
    );
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.otherLabs.filter(lab =>
      lab.labName.toLowerCase().includes(filterValue) &&
      !this.selectedOtherLabs.some(sel => sel.id === lab.id)
    );
  }

  selectLab(event: any): void {
    const selectedLab = event.option.value;
    
    // Add to chips display array
    if (!this.selectedOtherLabs.some(lab => lab.id === selectedLab.id)) {
      this.selectedOtherLabs.push(selectedLab);
      
      // Update the FormControl with IDs
      const currentIds = this.otherLabsControl.value || [];
      this.otherLabsControl.setValue([...currentIds, selectedLab.id]);
    }
    
    // Clear the input and trigger filter refresh
    this.labCtrl.setValue('');
    
    // Optional: Force refresh of filteredLabs
    this.refreshFilteredLabs();
  }

  removeLab(labToRemove: any): void {
    // Remove from chips display array
    this.selectedOtherLabs = this.selectedOtherLabs.filter(lab => lab.id !== labToRemove.id);
    
    // Update the FormControl
    const currentIds = this.otherLabsControl.value || [];
    this.otherLabsControl.setValue(currentIds.filter(id => id !== labToRemove.id));
    
    // Refresh filtered labs to show the removed lab again
    this.refreshFilteredLabs();
  }

  private refreshFilteredLabs(): void {
    // Force the filteredLabs observable to recalc
    const currentValue = this.labCtrl.value || '';
    // Emit the current value to retrigger the filtering
    this.labCtrl.setValue(currentValue);
  }


  getMainRgpdLabs(): void {
    this.isLoading = true;
    
    this.unsubscribe.add(this.rgpdService.getMainRgpdLabs().subscribe({
      next: (labs) => {
        this.mainLabs = labs;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading main RGPD labs', err);
        this.isLoading = false;
      }
    }));
  }

  getOtherRgpdLabs(): void {
    this.isLoading = true;
    
    this.unsubscribe.add(this.rgpdService.getOthersRgpdLabs().subscribe({
      next: (labs) => {
        this.otherLabs = labs;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading other RGPD labs', err);
        this.isLoading = false;
      }
    }));
  }

  setPreferences(decision:boolean): void {   
    const clientId = this.currentUser?.clientId;

    const preferences: RGPDPreferences = {
      decision: decision,
      n_Cliente: clientId,
      id_Labs: [
        ...this.selectedMainLabs, 
        ...this.selectedOtherLabs.map(lab => lab.id)
      ]    
    };

    this.unsubscribe.add(this.rgpdService.setPreferences(preferences).subscribe({
      next: () => {
        this.router.navigate(['/home']);
      },
      error: (err) => {
        console.error('Error saving preferences', err);
      }
    }));
  }

  ngOnDestroy(): void {
    this.unsubscribe.unsubscribe()
  }
}
